/*global chrome*/
import store, {history} from "@/redux/store";
import { Link, useNavigate } from "react-router-dom";
import React, { useState } from "react";
import { Suspense, lazy } from "react";
import { syncHistoryWithStore } from 'react-router-redux'
//import {showLoader,hideLoader} from "actions/types";
import { connect } from "react-redux";

import ModalPopupController from '@/controllers/modals/ModalPopup';

import FileUploadController from '@/controllers/FileUploadController';

import WindowController from '@/controllers/Window/WindowController';

import CustomerDetailController from '@/controllers/customers/CustomerDetailController';
import TeamDetailController from '@/controllers/team/TeamDetailController';
import TenantController from '@/controllers/Tenant/TenantController';
import AdminUserController from '@/controllers/admin/user/AdminUserController';
import SettingsController from '@/controllers/Settings/SettingsController';
import InvoiceController from '@/controllers/Invoice/InvoiceController';
//import WorkProcessController from '@/controllers/WorkProces/WorkProcessController';
import AgendaController from '@/controllers/Agenda/AgendaController';
import MyProfileController from '@/controllers/MyProfile/MyProfileController';
//import FileController from '@/controllers/Files/FileController';
import TimeRegistrationController from '@/controllers/TimeRegistration/TimeRegistrationController';
import LoginController, {RESETPASSWORD, RECOVERPASSWORD, REGISTRATION} from '@/controllers/authorisation/LoginController';
import DashboardController from '@/controllers/dashboard/DashboardController';
import { checkUserAuth } from '@/reducers/Authorisation'
import * as UserConst from "actions/userConst";
import * as CONST from "@/actions/globalConst";
import { loadUsers } from '@/reducers/User'
import MessageController from "@/controllers/Messages/MessageController";
import LogController from '@/controllers/Logging/LogController'
import ParentComponent, {ParenComponent} from '@/controllers/authorisation/ExternLoginController';
import RegistrationController from '@/controllers/authorisation/RegistrationController';
import TranslationController from '@/controllers/translation/TranslationController';

import messageSlice from '@/redux/messageSlice';
import PrivateRoute from '@/controllers/Router/PrivateRoute';

import {
  BrowserRouter as Router, browserHistory,
    Routes,
    Route, Navigate, useLocation, useParams
} from 'react-router-dom' 
import PublicRoute from "./Router/PublicRoute";
import NotificationController from "./Notification/NotificationController";

import { ApplicationLoader } from "@/views/Loaders/ApplicationLoader";
import RolesController from "./RBAC/RolesController";

import MediaController from '@/controllers/Media/Media';
import ModalBase from '@/components/timeline/view/modals/ModalBase'
import { CompanyDetail } from "@/views/Paperchip/Company/CompanyDetail";
import { TableView} from "@/views/Paperchip/Company/TableView";
import { Overview as TeamOverview } from "@/views/team/Overview";

const WorkProcessController = React.lazy(() => import('@/controllers/WorkProces/WorkProcessController'));
const DossiersController = React.lazy(() => import('@/controllers/Dossiers/DossiersController'));
const FileController = React.lazy(() => import('@/controllers/Files/FileController'));
const TeamController = React.lazy(() => import('@/controllers/team/TeamController'));
const CustomerController = React.lazy(() => import('@/controllers/customers/CustomerController'));
const ProspectController = React.lazy(() => import('@/controllers/Prospects/ProspectController'));



class AppController extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, isLoaded: false, secret: null };

  }

async checkAuth(){
            await store.dispatch(checkUserAuth()).then((event) => {
            //
                /*
                if(event.payload.data.data.dy) {
                    let str = event.payload.data.data.dy;
                     let t = eval("(" + JSON.parse(str) + ")");
                     
                    console.log( (t.isOld() ? "JA" : "NEE")  );
                }
                */
                
            });
    
}
  
   componentDidMount() {
       window.process = {
        ...window.process,
      };
      
    const { dispatch, selectedId } = this.props;
        if( this.props?.ApplicationReducer?.APP_STATE == CONST.APP_STATE.INIT ) {
            
            this.checkAuth();
            //store.dispatch(checkUserAuth()).then((event) => {
            //    
            //});
              // if(!store.getState().chat.isConnected) {
              //   store.dispatch(messageSlice.actions.startConnecting({})); 
              //   }
            
        }
    }
  render() {
      const {AuthReducer, ModalPopupReducer, DossierReducer, RedirectReducer, location} = this.props;
      if( this.props?.ApplicationReducer?.APP_STATE == CONST.APP_STATE.INIT || this.props?.ApplicationReducer?.APP_STATE == CONST.APP_STATE.LOADING_APP) {
          return ( <ApplicationLoader /> );
      }
      
      return (
          <>
              <Router history={history} key={this.props?.AuthReducer?.key}>
                  <Suspense fallback={<div>Loading...</div>}>
                       <Routes>
                       
                                                 
                       
                        <Route  path="/registrate/" element={<RegistrationController key="registrate" view={REGISTRATION}/>}></Route>
                        <Route  path="/registrate/:hash" element={<RegistrationController key="tenantRegistrate" view={REGISTRATION}/>}></Route>
                           <Route element={<PrivateRoute APP_PART={this.props?.ApplicationReducer?.APP_PART == CONST.APP_STATE.DASHBOARD_PART} />} >
                               <Route  path="/myprofile" element={<MyProfileController />}></Route>
                               
<Route key="dossierRoute" path={"/dossiers"} >
    <Route  index={true} element={<DossiersController key={"overview"}/>}></Route>
    <Route  path="new" element={<DossiersController key={"new"} view={"new"}/>}></Route>
    <Route  path="edit/:id" element={<DossiersController key={"edit"} view="edit"/>}></Route>
    <Route  path="edit/:id/:taskKey" element={<DossiersController key={"edit"} view="edit"/>}></Route>
    <Route  path="view/:id" element={<DossiersController key={"view"} view="view"/>}></Route>
    <Route  path="view/:id/:taskKey" element={<DossiersController key={"view"} view="view"/>}></Route>
</Route>

<Route key="prospectRoute" path={"/prospect"} >
    <Route  index={true} element={<ProspectController key={"overview"}/>}></Route>
</Route>
                               
<Route key={"abc"} path={"/wp"} >

    <Route  index={true} element={<WorkProcessController key="wpc"/>}></Route>
    <Route  path="add" element={<WorkProcessController key="addDossier" view="add"/>}></Route>
    <Route  path="edit/:id" element={<WorkProcessController key="editDossier" view="edit"/>}></Route>
</Route>
<Route key={"agenda1"} path={"/agenda"} >
    <Route  index={true} element={<AgendaController key="ag1"/>}></Route>
</Route>
                               
                               {AuthReducer?.megaadminmenu && AuthReducer?.megaadminmenu.map((menuItem) => (
                                   {
          'translation_admin': <Route key={menuItem.key} path={menuItem?.route} >
                            <Route  index={true} element={<TranslationController key="translation"/>}></Route>
                         </Route>,
          'tenant_admin': <Route key={menuItem.key} path={menuItem?.route} >
                            <Route  index={true} element={<TenantController key="tenantOverview"/>}></Route>
                            <Route  path="add" element={<TenantController key="addTentant" view="add"/>}></Route>
                            <Route  path="edit/:id" element={<TenantController key="editTentant" view="edit"/>}></Route>
                         </Route>,
          'user_admin': <Route key={menuItem.key} path={menuItem?.route} >
                            <Route  index={true} element={<AdminUserController key="adminUserOverview"/>}></Route>
                            <Route  path="edit/:id" element={<AdminUserController key="editAdminUser" view="edit"/>}></Route>
                         </Route>,
                                  }[menuItem.key] 
                               ))
                               }
                                   
                                   
                               {AuthReducer?.menu && AuthReducer?.menu.map((menuItem) => (
                                   {
          'files': <Route key={menuItem.key} path={menuItem?.route} >
                            <Route  index={true} element={<FileController key="filesOverview"/>}></Route>
                         </Route>,
          'intern_team': <Route key={menuItem.key} path={menuItem?.route} >
                            <Route  index={true} element={<TeamController type={1} key="intteam"/>}></Route>
                            <Route  index={false} path="add" element={<TeamDetailController  type={1} key="intteam_add"/>}></Route>
                            <Route  index={false} path="edit/:id" element={<TeamDetailController  type={1} key="intteam_edit"/>}></Route>
                         </Route>,
          'extern_team': <Route key={menuItem.key} path={menuItem?.route} >
                            <Route  index={true} element={<TeamController type={2} key="extteam"/>}></Route>
                            <Route  index={false} path="add" element={<TeamDetailController  type={2} key="extteam_add"/>}></Route>
                            <Route  index={false} path="edit/:id" element={<TeamDetailController  type={2} key="extteam_edit"/>}></Route>
                         </Route>,
          'customers': <Route key={menuItem.key} path={menuItem?.route} >
                            <Route  index={true} element={<CustomerController key="customers"/>}></Route>
                            <Route  index={false} path="add" element={<CompanyDetail />}></Route>
                            <Route  index={false} path="edit/:id" element={<CompanyDetail />}></Route>
                       </Route>,
          'prospect': <Route key={menuItem.key} path={menuItem?.route} >
                            <Route  index={true} element={<ProspectController key="prospects"/>}></Route>
                            <Route  index={false} path="detail/:id" element={<ProspectController />}></Route>
                       </Route>,
          'time_registration':  <Route key={menuItem.key} path={menuItem?.route} >
                                    <Route  index={true} element={<TimeRegistrationController key="timeregistration_overview"/>}></Route>
                                </Route>,
          'invoices': <Route key={menuItem.key} path={menuItem?.route} >
                        <Route  index={true}  element={<InvoiceController key="invoiceOverview" view="overview"/>}></Route>
                        <Route  path="create" element={<InvoiceController key="invoiceCreate" view="create"/>}></Route>
                      </Route>,
          'settings': <Route key={menuItem.key}  path={menuItem?.route} >
                        <Route  index={true} element={<SettingsController key="settingsOverview"/>}></Route>
                        <Route  path="storage" element={<SettingsController key="settingsOverview" selectedTab="storage"/>}></Route>
                      </Route>,
          'roles': <Route key={menuItem.key} path={menuItem?.route} >
                      <Route  index={true}  element={<RolesController key="rolesOverview"/>}></Route>
                      <Route  path="add" element={<RolesController key="roleCreate" view="add"/>}></Route>
                      <Route  path="edit/:id" element={<RolesController key="roleEdit" view="edit"/>}></Route>
                   </Route>,
        }[menuItem.key]
                               ))
                               }
                               




                               
                               
                               
                               
                               <Route  path="/" element={<DashboardController key="dashboard"/>}></Route>

                            </Route>

                                    <Route  path="/externlogin/:otp/" element={<ParentComponent />}></Route>
                           <Route element={<PublicRoute APP_PART={this.props?.ApplicationReducer?.APP_PART != CONST.APP_STATE.DASHBOARD_PART}/>} >
                                    <Route  path="/resetpassword/:hash/" element={<LoginController key="resetpassword" view={RECOVERPASSWORD}/>}></Route>
                                    <Route  path="/resetpassword/" element={<LoginController key="recoverpassword" view={RESETPASSWORD}/>}></Route>
                                    <Route  path="/login" element={<LoginController key="login"/>}></Route>
                           </Route>
                           
                           <Route exact path="*" element={<Navigate to="/" />} />
                        </Routes>
                        </Suspense>
                        
                        <NotificationController />
                  <ModalPopupController {...this.props} key={ModalPopupReducer.key}/>
                  <MessageController {...this.props} />
                  <ModalBase />
                  <WindowController />
              </Router>
                 
            </>      
      );
      
  }
}
const AppControllerInit = (props) => {
    

  return (
    <AppController {...props}/>
  );
};

function mapStateToProps(state) {
    const {AuthReducer, routing,ModalPopupReducer, ApplicationReducer, DossierReducer,RedirectReducer} = state
  return {
        key: ApplicationReducer.key,
        AuthReducer,
        routing,
        ModalPopupReducer,
        ApplicationReducer,
        DossierReducer,
        RedirectReducer
  };
}

export default connect(mapStateToProps)(AppControllerInit);  